import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { NavigationLink, NavigationLinkGroup, isNavigationLinkGroup } from './interfaces'
import VNavigationLinks from './VNavigationLinks.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'VNavigationLinks',
  props: {
    items: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (link) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: link.title
    }, [
      (_unref(isNavigationLinkGroup)(link))
        ? (_openBlock(), _createBlock(_component_v_list_group, {
            key: 0,
            value: link.title
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_list_item, _mergeProps(props, {
                title: link.title,
                "prepend-icon": link.icon
              }), null, 16, ["title", "prepend-icon"])
            ]),
            default: _withCtx(() => [
              _createVNode(VNavigationLinks, {
                items: link.children
              }, null, 8, ["items"])
            ]),
            _: 2
          }, 1032, ["value"]))
        : (_openBlock(), _createBlock(_component_v_list_item, {
            key: 1,
            to: link.url,
            "prepend-icon": link.icon
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, { class: "wrap-text" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(link.title), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["to", "prepend-icon"]))
    ], 64))
  }), 128))
}
}

})